import localforage from "localforage"
const name = "yomu"
export default localforage.createInstance({ name })
